import {Text, View} from "react-native";

function LoginMessages(props){
    if(props.hasError){
        return(
            <View style={{alignItems:'center',marginTop:'10'}}>
                <Text style={{color:'red'}}>{props.message}</Text>
            </View>
        )
    } else {
        return <></>
    }

}

export default LoginMessages